'use strict';

export function setTitleWidthOnWrappers(
  wrapperSelector,
  titleSelector,
  cssVarName = 'title-width',
  extraPixels = 55,
  listenToResize = true
) {
  function update() {
    document.querySelectorAll(wrapperSelector).forEach(wrapper => {
      const title = wrapper.querySelector(titleSelector);
      if (!title) {
        return;
      }

      const width = title.offsetWidth + extraPixels;
      wrapper.style.setProperty(`--${cssVarName}`, `${width}px`);
    });
  }

  window.addEventListener('load', update);
  if (listenToResize) window.addEventListener('resize', update);
}